import script from "./TutorialView.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialView.vue?vue&type=script&setup=true&lang=js"

import "./TutorialView.vue?vue&type=style&index=0&id=7470c934&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7470c934"]])

export default __exports__